// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPayoutDefinitionPlanDto
 */
export interface IPayoutDefinitionPlanDto {
    /**
     * 
     * @type {number}
     * @memberof IPayoutDefinitionPlanDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayoutDefinitionPlanDto
     */
    name?: string;
}

/**
 * Check if a given object implements the IPayoutDefinitionPlanDto interface.
 */
export function instanceOfIPayoutDefinitionPlanDto(value: object): value is IPayoutDefinitionPlanDto {
    return true;
}

export function IPayoutDefinitionPlanDtoFromJSON(json: any): IPayoutDefinitionPlanDto {
    return IPayoutDefinitionPlanDtoFromJSONTyped(json, false);
}

export function IPayoutDefinitionPlanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayoutDefinitionPlanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function IPayoutDefinitionPlanDtoToJSON(json: any): IPayoutDefinitionPlanDto {
    return IPayoutDefinitionPlanDtoToJSONTyped(json, false);
}

export function IPayoutDefinitionPlanDtoToJSONTyped(value?: IPayoutDefinitionPlanDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

